import { render, staticRenderFns } from "./ContactDetails.html?vue&type=template&id=1f3de788&scoped=true&"
import script from "./ContactDetails.js?vue&type=script&lang=js&"
export * from "./ContactDetails.js?vue&type=script&lang=js&"
import style0 from "./ContactDetails.scss?vue&type=style&index=0&id=1f3de788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3de788",
  null
  
)

export default component.exports